/**
 * [T-128] 消息通知 API.
 * 后端: /hl-drying/drying/notice/**
 *
 * 管理端 (/drying/notice):     send / page / delete / batch-delete / roles / users
 * 用户端 (/drying/notice/my):   page / read / read-all / unread-count
 */
import request from '@/utils/request'

const PREFIX = '/hl-drying/drying/notice'

// ============ 管理端 ============

/**
 * 发送通知 (手动)
 * @param {Object} dto
 *   { factoryId, title, content, noticeCategory, noticeLevel,
 *     targetType, targetValues:[], targetRoute }
 */
export function sendNotice(dto) {
  return request.post(`${PREFIX}/send`, dto)
}

/**
 * 管理端分页 (本厂全部自动/手动)
 * @param {Object} query { factoryId, pageNo, pageSize, noticeSource, noticeCategory, keyword }
 */
export function pageNoticeForAdmin(query) {
  return request.get(`${PREFIX}/page`, { params: query })
}

/** 删除单条 */
export function deleteNotice(id) {
  return request.delete(`${PREFIX}/${id}`)
}

/** 批量删除 */
export function batchDeleteNotice(ids) {
  return request.post(`${PREFIX}/batch-delete`, { ids })
}

/** 本厂可选角色 (发送通知下拉) */
export function listNoticeRoles(factoryId) {
  return request.get(`${PREFIX}/roles`, { params: { factoryId } })
}

/** 本厂可选用户 (发送通知下拉) */
export function listNoticeUsers(factoryId) {
  return request.get(`${PREFIX}/users`, { params: { factoryId } })
}

// ============ 用户端 ("我的通知") ============

/**
 * 我的通知分页
 * @param {Object} query { factoryId, pageNo, pageSize, noticeSource, noticeCategory, keyword, onlyUnread }
 */
export function pageNoticeForUser(query) {
  return request.get(`${PREFIX}/my/page`, { params: query })
}

/** 标记单条已读 */
export function markNoticeRead(noticeId, factoryId) {
  return request.put(`${PREFIX}/my/read/${noticeId}`, null, { params: { factoryId } })
}

/** 全部已读 */
export function readAllNotice(factoryId) {
  return request.put(`${PREFIX}/my/read-all`, null, { params: { factoryId } })
}

/**
 * 未读数 (总数十按子分类, MainLayout 轮询用)
 * @returns {Promise<{total, byCategory:{}}>}
 */
export function unreadCountNotice(factoryId) {
  return request.get(`${PREFIX}/my/unread-count`, { params: { factoryId } })
}
